import { IPermissionModel } from './';

export const IMRPermission: IPermissionModel[] = [
	{
		name: 'Dashboard',
		route: '/',
		components: [
			'user-sufficiency-summary',
			'focus-products',
			'attendance-check',
			'total-out-off-view-site',
			'total-site-leads-from-kae',
			'total-competition-site-visited',
			'total-site-visited',
		],
	},
	{ name: 'EndUsers', route: '/end-users', components: [] },
	{ name: 'NewLeads', route: '/end-users/new-leads', components: [] },
	{ name: 'All', route: '/end-users/all', components: [] },
	{ name: 'Scheme', route: '/scheme', components: [] },
	{ name: 'SiteSummary', route: '/site-summary', components: [] },
	{ name: 'Profile', route: '/profile', components: [] },
	{ name: 'CompetitionConversion', route: '/competition-conversion', components: [] },
	{ name: 'TypeOfContractor', route: '/competition-conversion/type-of-contractor', components: [] },
	{ name: 'GradeOfCompetition', route: '/competition-conversion/grade-of-competition', components: [] },
	{ name: 'ProductsRecommended', route: '/competition-conversion/products-recommended', components: [] },
	{ name: 'Gallery', route: '/gallery', components: [] },
	{ name: 'PCMS', route: '/pcms', components: [] },
	{ name: 'HelpAndSupport', route: '/help-and-support', components: [] },
	{ name: 'AddMemberDetails', route: '/add-member-details', components: [] },
	{ name: 'BasicDetails', route: '/add-member-details/basic-details', components: [] },
	{ name: 'KycDetails', route: '/add-member-details/kyc-details', components: ['imr-code-dropdown'] },
	{ name: 'MoreDetails', route: '/add-member-details/more-details', components: ['kae-carpenter-field'] },
	{ name: 'EditMemberDetails', route: '/edit-member-details', components: [] },
	{ name: 'EditBasicDetails', route: '/edit-member-details/basic-details', components: [] },
	{ name: 'EditKycDetails', route: '/edit-member-details/kyc-details', components: ['imr-code-dropdown'] },
	{ name: 'EditMoreDetails', route: '/edit-member-details/more-details', components: ['kae-carpenter-field'] },
	{ name: 'Contractor', route: '/contractor', components: ['tab-state', 'product-recommendation'] },
	{ name: 'BankingDetails', route: '/contractor/banking-details', components: [] },
	{ name: 'Calculator', route: '/contractor/calculator', components: [] },
	{ name: 'CalculatorAdditionalDetails', route: '/contractor/calculator/calculator-details', components: [] },
	{ name: 'BankingHistory', route: '/contractor/banking-history', components: [] },
	{ name: 'PointsStatement', route: '/contractor/points-statement', components: [] },
	{ name: 'RedemptionHistory', route: '/contractor/redemption-history', components: [] },
	{ name: 'QrCodeScanner', route: '/contractor/qr-code-scanner', components: [] },
	{ name: 'QrCodeCheck', route: '/contractor/qr-code-check', components: [] },
	{ name: 'QrCodeValidate', route: '/contractor/qr-code-validate', components: [] },
	{ name: 'SiteSummary', route: '/contractor/site-summary', components: [] },
	{ name: 'Calendar', route: '/calendar', components: [] },
	{ name: 'AddNewSite', route: '/add-new-site', components: ['kae-glue-fields'] },
	{ name: 'ActivityModule', route: '/activity-module', components: [] },
	{ name: 'UserSufficiencySummary', route: '/user-sufficiency-summary', components: [] },
	{ name: 'SiteLeadOverview', route: '/site-lead-overview', components: [] },
	{ name: 'SiteDetails', route: '/site-lead-overview/site-details', components: [] },
	{ name: 'VisitDetails', route: '/site-lead-overview/visit-details', components: [] },
	{ name: 'AddPcmsRegistration', route: '/add-pcms-registration', components: [] },
	{ name: 'EditPcmsRegistration', route: '/edit-pcms-registration', components: [] },
	{ name: 'StructureQuestionnaires', route: '/structured-questionnaires', components: [] },
	{ name: 'FieldMarketingContent', route: '/field-marketing-content', components: [] },
	{ name: 'Meetings', route: '/meetings', components: ['add-meeting-button'] },
	{ name: 'MeetingDetails', route: '/meeting-details', components: ['scheduled-meeting-button'] },
	{ name: 'TodayMeetings', route: '/today-meetings', components: ['todays-meeting'] },
	{ name: 'MeetingsConducted', route: '/meetings-conducted', components: ['meetings-conducted'] },
	{ name: 'TodaysMeetings', route: '/meetings/todays-meetings', components: ['imr-meeting-fields'] },
	{ name: 'AllMeetings', route: '/meetings/all-meetings', components: ['imr-meeting-fields'] },
	{ name: 'AttendanceDetails', route: '/today-meetings/attendance-details', components: ['imr-meeting-fields'] },
	{ name: 'ExpenseDetails', route: '/meetings-conducted/expense-details', components: ['imr-meeting-fields'] },
	{ name: 'CompletedRecord', route: '/meetings-conducted/completed-record', components: ['imr-meeting-fields'] },
	{ name: 'Jharokha', route: '/jharokha', components: [] },
	{ name: 'ACR Form', route: '/acr-form', components: [] },
];
